export const environment = {
    production: false,
    backent_ApiUrl:'https://test.swadhaagri.com/swadha_test2/public/api',
    imagePath:'https://swadhaagri.com/assets/images/',
};
